var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "payment-method-wrapper" },
    [
      _c("h2", { staticClass: "payment-method-title" }, [
        _vm._v(" " + _vm._s(_vm.$t("pages.billing.paymentMethod")) + " "),
      ]),
      _c(
        "ib-card",
        {
          staticClass:
            "payment-method-card d-flex flex-column flex-sm-row justify-content-between align-sm-center",
          attrs: { animation: false },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "last-used-payment d-flex flex-column flex-sm-row align-sm-center",
            },
            [
              _c("p", { staticClass: "m-0 mb-2 mb-sm-0 font-outfit-regular" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("pages.billing.lastUsedPaymentMethod")) +
                    " "
                ),
              ]),
              _vm.currentPaymentMethod
                ? [
                    _c("div", { staticClass: "d-flex align-center" }, [
                      _c("img", {
                        staticClass: "mr-2",
                        attrs: {
                          src: _vm.currentPaymentMethod.icon,
                          width: "22",
                          alt: "payment-method-logo",
                        },
                      }),
                      _c("span", { staticClass: "font-outfit-regular" }, [
                        _vm._v(
                          " " + _vm._s(_vm.currentPaymentMethod.name) + " "
                        ),
                      ]),
                    ]),
                  ]
                : _c("p", { staticClass: "m-0 font-outfit-regular" }, [
                    _vm._v(" " + _vm._s(_vm.$t("pages.billing.none")) + " "),
                  ]),
            ],
            2
          ),
          _c("div", [
            !_vm.subscriptionIsFreeTrial && _vm.userSubscription.update_url
              ? _c(
                  "div",
                  {
                    staticClass:
                      "billing-update-btn o-50 cursor-pointer font-outfit-medium",
                    on: { click: _vm.onUpdateSubscription },
                  },
                  [
                    _c("i", { staticClass: "ib-icon-edit-2 ib-icon" }),
                    _vm._v(" " + _vm._s(_vm.$t("pages.billing.update")) + " "),
                  ]
                )
              : _vm._e(),
          ]),
        ]
      ),
      !_vm.subscriptionIsFreeTrial
        ? _c("dialog-change-billing", {
            attrs: { visible: _vm.dialogChangeBillingVisible },
            on: {
              close: function ($event) {
                _vm.dialogChangeBillingVisible = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }